import * as React from 'react';
import styled from '@emotion/styled';
import produce from 'immer';
import { MatchedProperty } from './types';
import Highlight from '../../../components/Highlight';
import { SelectedCity } from './types';
import { useAddProperty } from './AddPropertyContext';

const OuterWrapper = styled.div`
  padding: 4px 8px;
  background-color: #fff;
  z-index: 500;
`;
const Row = styled.div`
  display: flex;
  //grid-template-columns: 25% 10% 26% 18% 35%;
  //grid-column-gap: 1%;
  gap: 8px;
  z-index: 500;
  padding: 8px 16px;
  cursor: pointer;
  :hover {
    background: #f7f7f9;
    border-radius: 4px;
  }
`;
interface Props {
  matches: Array<MatchedProperty>;
  handleOnSave?: (match: MatchedProperty[]) => void;
  searchText: string;
  propertyIndex: number;
  handleClick: (m: MatchedProperty, s: SelectedCity) => void;
  properties?:any
}

function RpadResults(props: Props) {
    const { properties } = useAddProperty();
    return (
      <div>
        {props.matches?.map(m => {
          return (
            <OuterWrapper>
              <Row
                onClick={() => {
                  props.handleClick(m, properties[props.propertyIndex].selectedCity);
                }}
              >
                <div style={{ width: 200 }}>{Highlight(m.address, props.searchText)}</div>
                <div style={{ width: 100 }}>{m.aptNo}</div>
                <div style={{ width: 200 }}>
                  {m.muniTypes.map((mt, index) => {
                    const trimmed = mt?.name.trim()
                    return <span>{`${index > 0 ? ', ' : ''}${trimmed}`}</span>;
                  })}
                </div>
                <div style={{ width: 200 }}>
                  {m.property.section}{' '}
                  <span style={{ paddingLeft: 4, paddingRight: 4 }}>{m.property.block}</span> {m.property.lot} {m.property.qualifier && m.property.qualifier}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: 200 }}>
                  {m.owners.map((owner, index) => {
                    return <div key={index}>{owner} </div>;
                  })}
                </div>
              </Row>
            </OuterWrapper>
          );
        })}
      </div>
    );
  }
  
  export default RpadResults;
